import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import React from "react";
import Header from "../components/header/header";
import Home from "../components/home/home";
import Footer from "../components/footer/footer";
import Acercade from "../components/acercade/acercade";
import { Contacto } from "../components/contacto/contacto";
import Politica from "../components/politicas/politicaspriv";
import { Condiciones } from "../components/condiciones/condiciones";
import Chatbot from '../components/chatbot/chatbot';
const genRoute=(path,element)=>{

    return (
        <Route path={path} element={element} />
    )



}
const Page= () => {
  return (
   <Router>
    <Header/>
    <main>
        
        <Routes>
               {genRoute("/",<Home/>)}
               {genRoute('/acercade',<Acercade/>)}
               {genRoute('/contacto',<Contacto/>)}
               {genRoute('/politicas',<Politica/>)}
               {genRoute('/condiciones',<Condiciones/>)}
        </Routes>
        <Footer/>
    </main>
    <Chatbot/>
   </Router>
  );
}
export default Page;
